import { Component, Input } from '@angular/core';
import { ColumnContext } from '@legacy/common-ui-shared-interfaces';
import type {
  IconCardAlignment,
  IconCardBackground,
  IconCardVariant,
} from '@legacy/common-ui-utility-components';
import { InnogyComponentRendering } from '@core/jss-models';
import { getDroplinkValue, getFieldValue, ScIconPipe } from '@core/jss-utils';
import { LocationService } from '@core/jss-seo';
import type { Item } from '@sitecore-jss/sitecore-jss/layout';
import {
  TrackImpressionDirective,
  TrackLinkDirective,
} from '@analytics/events';
import { IconCardButtonComponent } from '@legacy/common-ui-utility-components';
import { AutomationIdDirective } from '@innogy/utils-automation-id';

@Component({
  selector: 'wl-top-tasks-container',
  templateUrl: './top-tasks-container.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    TrackImpressionDirective,
    IconCardButtonComponent,
    AutomationIdDirective,
    TrackLinkDirective,
    ScIconPipe,
  ],
})
export class TopTasksContainerComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: InnogyComponentRendering;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() context?: ColumnContext;

  constructor(private readonly locationService: LocationService) {}

  public navigateToLink(href: string | undefined): void {
    this.locationService.navigateGeneralLink(href || '');
  }

  get topTasks() {
    return (this.rendering?.fields?.['topTasks'] as Item[]) || [];
  }

  get variant(): IconCardVariant {
    return (
      getDroplinkValue<IconCardVariant>(this.rendering?.fields, 'variant') ||
      'large'
    );
  }

  get variantMobile(): IconCardVariant {
    return getDroplinkValue<IconCardVariant>(
      this.rendering?.fields,
      'variantMobile',
      'small'
    );
  }

  get textAlignment(): IconCardAlignment {
    return getDroplinkValue<IconCardAlignment>(
      this.rendering?.fields,
      'textAlignment',
      'center'
    );
  }

  get textAlignmentMobile(): IconCardAlignment {
    return getDroplinkValue<IconCardAlignment>(
      this.rendering?.fields,
      'textAlignmentMobile',
      'left'
    );
  }

  get useLinkStyle() {
    return getFieldValue<boolean>(this.rendering, 'useLinkStyle', false);
  }

  get alignVertically() {
    return getFieldValue<boolean>(
      this.rendering,
      'alignItemsVertically',
      false
    );
  }

  get background(): IconCardBackground {
    return getDroplinkValue<IconCardBackground>(
      this.rendering?.fields,
      'background',
      'white'
    );
  }

  get hoverBackground(): IconCardBackground {
    return getDroplinkValue<IconCardBackground>(
      this.rendering?.fields,
      'hoverBackground',
      'brand'
    );
  }

  get hasEvenAmountOfTopTasks(): boolean {
    return !(this.topTasks.length % 2);
  }
}
